import axios from 'axios';
import { getNonGwApiRoot } from '../../../constants/ParamountReactConstants';
import * as utils from '../../../utils/Utils';

export function fetchReceiverImportLogs(limit = 200) {
  const params = utils.createURL([{ name: 'limit', values: limit }]);
  return {
    type: 'FETCH_RECEIVER_IMPORT_LOGS',
    payload: axios.get(`${getNonGwApiRoot()}/imports/logs${params}`),
  };
}
